import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";

const urlBase = `${config.urlApi}/Cliente`;  //import.meta.env.VITE_URL_API;

const urls = {
  login: `${urlBase}`,
  obterDados: `${urlBase}/Dados`,
  obterParceiros: `${urlBase}/Parceiros`,
  obterCidades: `${urlBase}/Cidades`,
  loginExterno: `${urlBase}/LoginExterno`,
  alterarSenha: `${urlBase}/AlterarSenha`,
}


function getToken(): string {

  const userJson = localStorage.getItem('user');
  if (!userJson) {
    return "";
  }
  
  const user = JSON.parse(userJson) as ClienteLoginResult;
  const accessToken = user.accessToken;

  if (accessToken != null) {
    return `Bearer ${accessToken}`;
  } else {
    return "";
  }
}

export const Login = (param: ClienteLogin): Promise<ClienteLoginResult> => {
  return new Promise((resolve, reject) => {

    axios
      .post(`${urls.login}`, param)
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao cliente fazer login")));
  });
};

export const logout = () => {
  localStorage.clear();
  axios.defaults.headers.common.Authorization = "";
};

export const obterDados = (): Promise<DadosCliente> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obterDados)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export const obterParceiros = (filtros: ClienteParceirosFiltros): Promise<ParceiroResult> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.obterParceiros, filtros)
      .then((r) => {
        const retorno = r.data as ParceiroResult;
        console.log("definindo urls de imagens dos parceiros");
        retorno.dados.forEach(p => {
          if (p.arquivo != null && p.arquivo != "")
          {
            p.arquivo = `${config.urlApi}/parceiros/${p.parceiroId}/${p.arquivo}`;
          }
        });

        return resolve(retorno);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};


export const obterCidades = (): Promise<Cidade[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.obterCidades)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};




export const alterarSenha = (senhaAtual: string, senhaNova: string, senhaNovaConfirmacao: string): Promise<{ mensagem: string }> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();
    axios
      .post(urls.alterarSenha, { senhaAtual, senhaNova, senhaNovaConfirmacao })
      .then((r) => resolve(r.data))
      .catch(error => reject(new ApiException(error || "Falha ao alterar senha")));
  });
};

export const loginExterno = (param: ClienteLoginExterno): Promise<ClienteLoginResult> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.loginExterno, param)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao realizar login externo")));
  });
};


export const SalvarAssinaturaBase64 = (docto: UploadAssinaturaDto): Promise<string> => {
  return new Promise((resolve, reject) => {

    const formData = new FormData();
    formData.append('contratoId', docto.contratoId.toString());
    formData.append('arquivoBase64', docto.arquivoBase64);

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(`${urlBase}/SalvarAssinaturaBase64?id=${docto.contratoId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao fazer upload da assinatura")));
  });
};



export interface ClienteLogin {
    cpf: string;
    senha: string;
}

export interface ClienteLoginResult {
    userName: string;
    role: string;
    accessToken: string;
    refreshToken: any;
    clienteId: number;
    nome: string;
}

export interface ClienteParceirosFiltros {
    pesquisa: string;
    parceiroId: number | null;
    cidadeId: number | null;
    categoriaId: number | null;
    paginaAtual: number;
    tamanhoPagina: number;
}


/* Dados */
export interface DadosCliente {
    cliente: Cliente;
    contratos: Contrato[];
    boletos: Boleto[];
    dependentes: Dependente[];
    mensalidades: Mensalidade[];
    categorias: Categoria[];
}

export interface Dependente  {
    dependenteId: number;
    clienteId: number;
    usuarioId: number;
    parentesco: string | null;
    nome: string;
    cpf: string | null;
    dataNascimento: string | null;
    celular: string | null;
    observacoes: string | null;
    ativo: boolean;
}

export interface Cliente {
    clienteId: number;
    usuarioId: number;
    nome: string;
    cpf: string | null;
    rg: string | null;
    rgExpedidor: string | null;
    telefone: string | null;
    celular: string | null;
    logradouro: string | null;
    numero: string;
    bairro: string | null;
    cidadeId: number | null;
    cep: string | null;
    complemento: string | null;
    nomeConjuge: string | null;
    cpfConjuge: string | null;
    cortesia: boolean;
    dataEntregaCartao: string | null;
    dataNascimento: string | null;
    empresaId: number | null;
    email: string | null;
    observacoes: string | null;
    permCartao: boolean;
    senha: string | null;
    ativo: boolean;
}

export interface Boleto {
    boletoId: number;
    empresaId: number;
    paramBoletoId: number;
    banco: string | null;
    agencia: string | null;
    posto: string | null;
    conta: string | null;
    codigoGeracao: string;
    numeroDocumento: string;
    parcela: number;
    totalParcelas: number;
    nossoNumero: string;
    carteira: string;
    valorDocumento: number;
    dataVencimento: string | null;
    dataDocumento: string | null;
    dataProcessamento: string | null;
    dataAbatimento: string | null;
    valorAbatimento: number;
    dataDesconto: string | null;
    tipoDesconto: string;
    vlrDesconto: number;
    codigoMora: string;
    valorMoraJuros: number;
    dataMoraJuros: string | null;
    valorIOF: number;
    valorOutrasDespesas: number;
    dataMulta: string | null;
    valorMultaFixo: boolean;
    percMulta: number;
    diasDeProtesto: number;
    dataProtesto: string | null;
    tipoDiasProtesto: string;
    diasDeNegativacao: number | null;
    dataNegativacao: string | null;
    codigoNegativacao: string;
    tipoDiasNegativacao: string;
    dataBaixa: string | null;
    dataLimitePagto: string | null;
    especie: string;
    especieMod: string;
    sacadoNome: string;
    sacadoPessoa: string;
    sacadoCpfCnpj: string;
    sacadoLogradouro: string;
    sacadoNumero: string;
    sacadoBairro: string;
    sacadoComplemento: string | null;
    sacadoCidade: string;
    sacadoUF: string;
    sacadoCep: string;
    sacadoEmail: string | null;
    avalistaNome: string | null;
    avalistaPessoa: string | null;
    avalistaCpfCnpj: string | null;
    avalistaLogradouro: string | null;
    avalistaNumero: string | null;
    avalistaBairro: string | null;
    avalistaComplemento: string | null;
    avalistaCidade: string | null;
    avalistaUF: string | null;
    avalistaCep: string | null;
    avalistaEmail: string | null;
    avalistaInscricaoNr: string | null;
    mensagemLinhas: string | null;
    informativoLinhas: string | null;
    detalhamentoLinhas: string | null;
    instrucao1: string | null;
    instrucao2: string | null;
    aceite: boolean;
    ocorrenciaTipo: string;
    seuNumero: string;
    tipoImpressao: string;
    carteiraEnvio: string;
    linhaDigitavel: string | null;
    codigoBarras: string | null;
    clienteId: number | null;
    contratoId: number | null;
    arquivo: string | null;
    ocorrenciaId: string;
    statusId: number;
    urlPix: string | null;
    emv: string | null;
    status: BoletoStatus;
}

export interface BoletoStatus {
    statusId: number;
    descricao: string;
    ordemExibir: number;
    classeCor: string;
    classeIcone: string;
    podeAlterar: boolean;
    podeRemessa: boolean;
    podeImprimir: boolean;
    podeBaixar: boolean;
    podeProtestar: boolean;
    podeSustarProtesto: boolean;
    podeExcluir: boolean;
}



export interface Mensalidade {
    contratoId: number;
    mensalidadeId: number;
    parcela: number;
    dataVencimento: Date;
    dataPagamento?: Date;
    valor: number;
    situacao: string;
    boletoId?: number | null;
    boletoAntigo: boolean;
}

export interface ParceiroResult {
    dados: Parceiro[];
    totalRegistros: number;
}
export interface Parceiro {
    parceiroId: number;
    usuarioId: number | null;
    nome: string;
    cnpj: string | null;
    logradouro: string | null;
    numero: string | null;
    bairro: string | null;
    cidadeId: number | null;
    uF: string | null;
    cep: string | null;
    complemento: string | null;
    telefone: string | null;
    celular: string | null;
    valorDescontoIni: number | null;
    valorDesconto: number | null;
    voucher: boolean;
    ativo: boolean;
    texto: string | null;
    textoContrato: string | null;
    foto: string | null;
    arquivo: string | null;
    dataAssinatura: string | null;
    assinatura: string | null;
    responsavel: string | null;
    cidade: Cidade | null;
}



export interface Cidade {
    cidadeId: number;
    nome: string;
    estado: string;
    ativo: boolean;
}


export interface Categoria  {
    categoriaId: number;
    descricao: string;
    ativo: boolean;
}



export interface Contrato {
  contratoId: number;
  planoId: number;
  plano: plano;
  vendedorId: number | null;
 
  investidorId: number | null;
  investidor: Usuario | null;
  supervisorId: number | null;
  supervisor: Usuario | null;
  clienteId: number | null;
  empresaId: number | null;
  preContrato: boolean | null;
  dataPriParcela: Date | null;
  statusId: number;
  
  dataInicio: string | null;
  dataFim: string | null;
  assinatura: string | null;
  dataAssinatura: string | null;
  arquivo: string | null;
  texto: string | null;
  observacoes: string | null;

  dataCadastro: string | null;
  usuCadastroId: number | null;
  dataAlteracao: string | null;
  usuAlteracaoId: number | null;
  dataExclusao: string | null;
  usuExclusaoId: number | null;

  status: ContratoStatus;
  vendedor: Usuario | null;
  cliente: Cliente | null;
  empresa: Empresa | null;
}


export interface Empresa {
  empresaId : number;
  nome: string;
  cnpj: string;
}

export interface ContratoStatus {
  statusId: number;
  descricao: string;
}

export interface plano {
  planoId: number;
  nome: string;
}

export interface Usuario {
  usuarioId: number;
  nomeCompleto: string;
}

export interface UploadAssinaturaDto {
  contratoId: number;
  arquivoBase64: string;
}

  export interface  ClienteLoginExterno
  {
      clienteId: number | null;
      senha: string;
  }

